import "./styles.scss";

export default function Footer() {

  return (
    <div>
      
    </div>
  );
}
